<svelte:options runes={false} />
<script>
  // The advisory rebalance ticket (TASK-K2T-8): the orders it would take to close the drift, gated by
  // the same deadband + min-notional the engine's own rebalance applies. STRICTLY advisory — the
  // Integrity tab is read-only by construction and places nothing; the assumptions are printed on the
  // panel (design rule: estimates are labeled, never implicit).
  import { fmtDrift, displaySymbol as display } from '../../../lib/integrity.js';
  import { formatNum } from '../../../lib/lineage.js';

  export let ticket = [];
  export let assumptions = null; // { deadbandWeight, minNotional, estCostBps }
</script>

{#if (ticket ?? []).length === 0}
  <div class="empty-state"><p class="empty-state-description">No drift past the deadband — the book sits on target.</p></div>
{:else}
  <table>
    <thead>
      <tr><th>Symbol</th><th>Side</th><th class="num">Δ weight</th><th class="num">Notional</th><th class="num">Est cost</th><th class="num">≈ Qty</th><th class="num">Depth @ touch</th><th class="num">≈ Part.</th></tr>
    </thead>
    <tbody>
      {#each ticket as t (t.symbol)}
        <tr>
          <td>{display(t.symbol)}</td>
          <td class="it-side-{t.side}">{t.side}</td>
          <td class="num">{fmtDrift(t.deltaWeight)}</td>
          <td class="num">{formatNum(t.notional, 2)}</td>
          <td class="num">{formatNum(t.estCost, 2)}</td>
          <td class="num">{t.qty != null ? formatNum(t.qty, 8) : '—'}</td>
          <!-- TASK-K2T-15 (AC 10): from the witness tape when THAT symbol's quote is fresh — else the honest dash. -->
          <td class="num">{t.depthAtTouch != null ? formatNum(t.depthAtTouch, 2) : '—'}</td>
          <td class="num">{t.estParticipationPct != null ? `${formatNum(t.estParticipationPct, 2)}%` : '—'}</td>
        </tr>
      {/each}
    </tbody>
  </table>
{/if}
{#if assumptions}
  <p class="it-assumptions">
    advisory only — deadband {fmtDrift(assumptions.deadbandWeight)} · min notional {formatNum(assumptions.minNotional, 0)} · est cost {assumptions.estCostBps} bps (modeled) · depth/participation from the live tape (est., per-symbol freshness)
  </p>
{/if}

<style>
  table { width: 100%; border-collapse: collapse; font-size: 0.75rem; }
  th, td { padding: 0.32rem 0.5rem; border-bottom: 1px solid var(--border-subtle, #1e1f22); white-space: nowrap; text-align: left; }
  th { font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--text-muted, #8a8b8d); }
  th.num, td.num { text-align: right; font-variant-numeric: tabular-nums; }
  .it-side-buy { color: var(--success, #1aa260); font-weight: 700; }
  .it-side-sell { color: var(--danger, #e0533a); font-weight: 700; }
  .it-assumptions { margin: 0.4rem 0 0; font-size: 0.64rem; color: var(--text-muted, #8a8b8d); }
</style>
